const adminSignRouter = [
  {
    path: '/admin/sign',
    name: 'AdminSignIndex',
    component: () => import('@/views/admin/sign/index')
  },
  {
    path: '/admin/sign/create',
    name: 'AdminSignCreate',
    component: () => import('@/views/admin/sign/create')
  },
  {
    path: '/admin/sign/edit',
    name: 'AdminSignEdit',
    component: () => import('@/views/admin/sign/edit')
  },
  {
    path: '/admin/sign/result',
    name: 'AdminSignResult',
    component: () => import('@/views/admin/sign/result')
  },
  {
    path: '/admin/sign/link',
    name: 'AdminSignLink',
    component: () => import('@/views/admin/sign/link')
  },
  {
    path: '/admin/sign/verify',
    name: 'AdminSignVerify',
    component: () => import('@/views/admin/sign/verify')
  },
  {
    path: '/admin/sign/printer',
    name: 'AdminSignPrinter',
    component: () => import('@/views/admin/sign/printer')
  },
  {
    path: '/admin/sign/member/create',
    name: 'AdminSignMemberCreate',
    component: () => import('@/views/admin/sign/memberCreate')
  }
]

export default adminSignRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/sign.js